import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { OrderStatusBlockConfig } from '@front-platform/content-builder';
import { orderStatusBlockResolveConfig } from '@front-platform/content-builder';
import { Observable } from 'rxjs';
import { Component, Inject, computed, input } from '@angular/core';

import { OrderTypeValues } from 'src/app/config/values/order.values';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { RouterHelperService } from 'src/app/core/services/router-helper/router-helper.service';

import {
  ORDER_STATUS_BLOCK_DATA_SOURCE,
  OrderStatusBlockDataSource,
  OrderStatusBlockViewModel,
} from './order-status-block-view-model';
import { provideOrderStatusBlockDataSource } from './order-status-block-data-source.providers';

export interface OrderStatusBlockRuntimeConfig {}

export type OrderStatusBlockConfigInput = Partial<
  Omit<OrderStatusBlockConfig, keyof OrderStatusBlockRuntimeConfig> & OrderStatusBlockRuntimeConfig
>;
export type OrderStatusBlockResolvedConfig = Omit<
  OrderStatusBlockConfig,
  keyof OrderStatusBlockRuntimeConfig
> &
  Partial<OrderStatusBlockRuntimeConfig>;
export interface OrderStatusBlockContract extends ConfigComponentContract<
  OrderStatusBlockConfigInput,
  OrderStatusBlockResolvedConfig
> {}

@Component({
  selector: 'app-order-status-block',
  templateUrl: './order-status-block.component.html',
  standalone: false,
  providers: [...provideOrderStatusBlockDataSource()],
})
export class OrderStatusBlockComponent implements OrderStatusBlockContract {
  readonly config = input<OrderStatusBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    OrderStatusBlockConfig,
    OrderStatusBlockRuntimeConfig
  >(orderStatusBlockResolveConfig, () => ({ config: this.config() }));
  textColor = computed(
    () => this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor,
  );
  secondaryTextColor = computed(
    () => this.resolvedConfig()['secondary_text_color'] as unknown as IContentBuilderFieldColor,
  );

  orderTypeValues = OrderTypeValues;
  protected readonly orderStatusVm$: Observable<OrderStatusBlockViewModel>;

  displayShopContact = computed(
    () => this.resolvedConfig()['display_shop_contact'] as unknown as boolean,
  );
  displayLocalizeButton = computed(
    () => this.resolvedConfig()['display_localize_button'] as unknown as boolean,
  );
  displayDetailsButton = computed(
    () => this.resolvedConfig()['display_details_button'] as unknown as boolean,
  );
  displayOrderStatus = computed(
    () => this.resolvedConfig()['display_order_status'] as unknown as boolean,
  );
  onSiteTimeSource = computed(
    () => this.resolvedConfig()['on_site_time_source'] as 'created_at' | 'ready_at',
  );
  onSiteCreatedAtLabel = computed(() => this.resolvedConfig()['on_site_created_at_label']);
  onSiteReadyAtLabel = computed(() => this.resolvedConfig()['on_site_ready_at_label']);
  displayCustomButton = computed(
    () => this.resolvedConfig()['display_custom_button'] as unknown as boolean,
  );
  customButtonText = computed(
    () => this.resolvedConfig()['custom_button_text'] as unknown as string,
  );
  customButtonUrl = computed(() => this.resolvedConfig()['custom_button_url'] as unknown as string);

  constructor(
    readonly routerHelper: RouterHelperService,
    @Inject(ORDER_STATUS_BLOCK_DATA_SOURCE) blockDataSource: OrderStatusBlockDataSource,
  ) {
    this.orderStatusVm$ = blockDataSource.vm$;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(OrderStatusBlockComponent, { 'keyAliases': {} });
